export default "__VITE_ASSET__BVfbVgBl__"